<template>
  <div id="app" :style="{ fontFamily: clientFont }">
    <router-view></router-view>
  </div>
</template>

<script>
  import client from '@/main.js'

  export default {
    name: 'App',
    data() {
      return {
        client: null
      }
    },
    created() {
      let me = this
      me.client = client.CLIENT
      document.title = client.clientData.name
    },
    computed: {
      clientFont() {
        return this.client === 'DOE-AL'
          ? 'HKGroteskPro, sans-serif !important'
          : 'Roboto, sans-serif !important'
      }
    }
  }
</script>

<style lang="scss">
  body {
    font-family: 'Roboto', sans-serif !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue